//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { getRightsCapabilitiesMultiHandle } from '@apis/rights-management/rightsManagementApi';
import PartialCuid from '@models/PartialCuid';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export const useGraphRightsCapabilityQuery = <TData = boolean>(
  cuid: PartialCuid,
  select?: (data: boolean) => TData,
  enabled?: boolean,
) => {
  return useQuery({
    enabled,
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsRightsCapabilities,
      cuid,
    ],
    queryFn: async ({ signal }) =>
      await getRightsCapabilitiesMultiHandle({ cuid }, { signal }),
    select,
    staleTime: FIVE_MINUTES_STALE_TIME,
  });
};
